module.exports = __webpack_public_path__ + "static/img/tjsp2.494fe2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tjsp2.png
// module id = 389
// module chunks = 0